import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';
import './styles/custom.scss'; // Import our custom Bootstrap styles

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //Remove strict mode in development as it causes useEffect to execute twice. Which means 2 times the API calls.
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
